// extracted by mini-css-extract-plugin
export default {"leagueListContainer":"LeagueList_leagueListContainer__S+aIt"};